
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/adform",
      function () {
        return require("private-next-pages/destinations/adform.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/adform"])
      });
    }
  